import { CheckboxTable, TextSwitchVariant } from '@makyoapp/makyo-ui'

import { WrapperProps } from '@/shared/routes'
import { ChangeSaved } from '@/components/ChangeSaved'
import Layout from '@/components/Layout'

import useMyNotificationSettings from './hooks/useMyNotificationSettings'

/**
 * MyNotificationSettings is a function component that renders the user's notification settings page.
 * It uses the useMyNotificationSettings custom hook to handle the settings.
 *
 * @param {Object} props - The component's props.
 * @param {string} props.title - The title of the page.
 *
 * @returns {JSX.Element} The rendered component.
 */
export default function MyNotificationSettings(props: WrapperProps) {
  const { isSaved, isSaving, values, keys, handleClick, handleCheckAll, t, checkAllData } = useMyNotificationSettings() // Using the custom hook

  const filteredValues = values?.map((section) => {
    if (section.label === 'Account') {
      const filteredChecks = { ...section.checks }
      delete filteredChecks['Sign Up Pin']
      delete filteredChecks['Sign In Pin']
      return { ...section, checks: filteredChecks }
    }
    return section
  })

  return (
    <Layout
      title={props.title} // Setting the page title
      actions={<ChangeSaved isSaving={isSaving} isSaved={isSaved} />} // Rendering the ChangeSaved component with isSaving and isSaved props
    >
      {values && (
        <CheckboxTable // Rendering the CheckboxTable component with necessary props
          id='notif-stg'
          useSwitch={true}
          keys={keys}
          values={filteredValues || []}
          renderTitle={(label) => t(label)}
          renderLabel={(label) => t(label)}
          onClick={handleClick}
          switchProps={{
            textOn: t('Off'),
            textOff: t('On'),
            textClassName: 'uppercase px-2',
            noPadding: true,
            variant: TextSwitchVariant.Corner,
          }}
          withCheckAll
          checkAll={checkAllData}
          onCheckAll={handleCheckAll}
        />
      )}
    </Layout>
  )
}
